import { render, staticRenderFns } from "./Pickup.vue?vue&type=template&id=1f1faaec&"
import script from "./Pickup.vue?vue&type=script&lang=ts&"
export * from "./Pickup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports